'use client'

import React, {useState} from "react";
import {ConfigProvider, Menu} from 'antd';
import {
    HeaderLogo, HeaderNavbar,
    HeaderNavbarButtonsWrapper,
    HeaderNavbarWrapper,
    HeaderStyled, LanguageSelectWrapper, LogoutBtnBurgerGroupWrapper, MobileNavbar, MobileNavbarWrapper
} from "@/components/Auth/Header/Header.styled";
import Button from "@/components/UI/Button/Button";
import BurgerMenuIcon from "@/public/icons/burger-menu.svg";
import {getSidebarItems} from "@/helpers/sidebar";
import {Link, usePathname, useRouter} from "@/helpers/navigation";
import createExternalLink from "@/hocs/createExternalLink";
import LanguageChooser from "@/components/UI/Form/Selects/LanguageChooser/LanguageChooser";
import CookieManager from "@/managers/cookie.manager";
import {useLogoutMutation} from "@/store/api/v1/user";
import {useTranslations} from "next-intl";
import {useDispatch} from "react-redux";


const TenantLink = createExternalLink({
    baseUrl: process.env.NEXT_PUBLIC_LANDING_URL,
    locale: true,
    component: Link
})

const Header = () => {
    const [open, setOpen] = useState(false)
    const pathname = usePathname()
    const router = useRouter()
    const dispatch = useDispatch()
    const [logout] = useLogoutMutation()
    const t = useTranslations('Auth')

    const [navigationItems, selected] = getSidebarItems(pathname,[
        {
            key: '#home',
            label: t('Header.home'),
        },
        {
            key: '#features',
            label: t('Header.features'),
        },
        {
            key: 'pricing',
            label: t('Header.pricing'),
        },
        {
            key: 'contact-us',
            label: t('Header.contact_us'),
        },
    ], {wrapper: TenantLink})

    const theme = {
        components: {
            Menu: {
                itemSelectedBg: 'none',
                itemActiveBg: 'none',
                itemHoverColor: '#0080FF !important',
                motionDurationMid: '0s',
                motionDurationSlow: '0s',
                padding: 'clamp(5px, 2vw, 20px)',
            },
        },
    }

    const menuStyle = {
        flex: 1,
        minWidth: 0,
        background: 'transparent',
        boxShadow: 'none',
    }

    const showDrawer = () => {
        setOpen(true)
    }
    const onClose = () => {
        setOpen(false)
    }

    const handleLogout = async () => {
        await logout()

        dispatch({ type: 'auth/logout' })

        CookieManager.removeItem('accessToken')
        window.location.reload()
        //router.push('/signin')
    }

    return (
        <HeaderStyled>
            <TenantLink>
                <HeaderLogo/>
            </TenantLink>

            <ConfigProvider
                theme={theme}
            >
                <HeaderNavbarWrapper>
                    <HeaderNavbar>
                        <Menu
                            items={navigationItems}
                            style={menuStyle}
                            defaultSelectedKeys={[selected]}
                        />
                    </HeaderNavbar>

                    <HeaderNavbarButtonsWrapper>
                        {
                            pathname === '/business' || pathname === '/verify-email'
                            ?
                            <Button
                                size={'sm'}
                                color={'light'}
                                onClick={handleLogout}
                            >
                                {t('Buttons.logout')}
                            </Button>
                            :
                            <>
                                <Button
                                    size={'sm'}
                                    color={'light'}
                                    onClick={() => router.push('signin')}
                                >
                                    {t('Buttons.login')}
                                </Button>
                                <Button
                                    size={'sm'}
                                    color={'secondaryDark'}
                                    onClick={() => router.push('signup')}
                                >
                                    {t('Buttons.sign_up')}
                                </Button>
                            </>
                        }
                    </HeaderNavbarButtonsWrapper>

                    <LanguageSelectWrapper>
                        <LanguageChooser />
                    </LanguageSelectWrapper>
                </HeaderNavbarWrapper>

                <MobileNavbarWrapper>
                    <LogoutBtnBurgerGroupWrapper>
                        {
                            pathname === '/business' &&
                            <Button
                                size={'sm'}
                                color={'light'}
                                onClick={handleLogout}
                            >
                                {t('Buttons.logout')}
                            </Button>
                        }
                        <BurgerMenuIcon onClick={showDrawer}/>
                    </LogoutBtnBurgerGroupWrapper>
                    <MobileNavbar width={'100%'} onClose={onClose} open={open}>
                        <Menu
                            items={navigationItems}
                            style={menuStyle}
                            defaultSelectedKeys={[selected]}
                            onClick={onClose}
                        />
                        <LanguageSelectWrapper>
                            <LanguageChooser/>
                        </LanguageSelectWrapper>
                    </MobileNavbar>
                </MobileNavbarWrapper>
            </ConfigProvider>
        </HeaderStyled>
    );
};
export default Header;
